import React from "react";

import HighlightBlock from "./HighlightBlock";
import { Swiper, SwiperSlide } from "swiper/react";

export default function ProjectsGrid({ projects = [], highlightBlockProps = {} }) {
    const isScrollable = projects.length > 4;

    return (
        <section className="projects-grid">
            <div className="container">
                <HighlightBlock {...highlightBlockProps}>
                    <div className="d-none d-lg-block">
                        <div
                            className={`projects-row-desktop d-flex gap-3 ${isScrollable ? "scrollable-x" : ""}`}
                            style={{
                                overflowX: isScrollable ? "auto" : "unset",
                                flexWrap: isScrollable ? "nowrap" : "wrap",
                                paddingBottom: isScrollable ? 8 : 0,
                            }}
                        >
                            {projects.map((p) => (
                                <div
                                    key={p.id}
                                    className="project-card position-relative rounded-4 overflow-hidden d-block"
                                    style={
                                        isScrollable
                                            ? {
                                                minWidth: "23%",
                                                maxWidth: "23%",
                                                flex: "0 0 23%",
                                                marginRight: 16,
                                            }
                                            : {
                                                flex: "1 1 0",
                                                minWidth: 0,
                                                marginRight: 16,
                                            }
                                    }
                                >
                                    <a href={p.link} tabIndex={0}>
                                        <img src={p.image} alt={p.title} className="project-card__img w-100 h-100" />
                                        <div className="project-card__caption position-absolute bottom-0 left-0 w-100 p-3">
                                            <h4 className="project-card__title">{p.title} <span className="project-card__subtitle">{p.subtitle}</span></h4>
                                        </div>
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>


                    <div className="d-lg-none">
                        <Swiper
                            loop
                            spaceBetween={16}
                            slidesPerView={1.12}
                            breakpoints={{
                                400: { slidesPerView: 1.25 },
                                576: { slidesPerView: 1.7 },
                                768: { slidesPerView: 2.2 },
                            }}
                            pagination={{ clickable: true }}
                            style={{ paddingBottom: 24 }}
                        >
                            {projects.map((p) => (
                                <SwiperSlide key={p.id}>
                                    <a href={p.link} className="project-card project-card--swiper position-relative rounded-4 overflow-hidden d-block mx-1">
                                        <img src={p.image} alt={p.title} className="project-card__img w-100" />
                                        <div className="project-card__caption position-absolute bottom-0 left-0 w-100 p-3">
                                            <h4 className="project-card__title">{p.title} <span className="project-card__subtitle">{p.subtitle}</span></h4>
                                        </div>
                                    </a>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </HighlightBlock>
            </div>
        </section>
    );
}
